import { mediaURLGQLFields } from './mediaURL.fields.js';
export const signedUrlGQLFields = () => {
    return `
    fields
    mediaId
    mediaUrl
    mediaDownloadUrl
    signedUrl
    urls {
      ${mediaURLGQLFields()}
    }
  `;
};
//# sourceMappingURL=signedUrl.fields.js.map